module.exports = __webpack_public_path__ + "img/revenge.719e228f.png";